var LimitExerciseEvent = {}
//活动boss信息
LimitExerciseEvent.LimitExercise_Message_Event = "LimitExerciseEvent.LimitExercise_Message_Event"
//领取宝箱
LimitExerciseEvent.LimitExercise_GetBox_Event = "LimitExerciseEvent.LimitExercise_GetBox_Event"
//购买次数
LimitExerciseEvent.LimitExercise_BuyCount_Event = "LimitExerciseEvent.LimitExercise_BuyCount_Event"


module.exports = LimitExerciseEvent